import React from 'react';

class RollingText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      text: '',
      textToBe: this.props.text,
      type: this.props.type || 'div',
      trigger: null
    };
  }

  componentDidMount() {
    let state = this.state;
    let props = this.props;
    let resolve = this.props.resolve;
    let speed = 600.0 / this.state.textToBe.length;

    let func = () => {
      if(!state.textToBe[state.text.length]) {
        state.textToBe = new Array(state.text).join('a').split('').map(a => '');
        if(resolve) {
          resolve();
        }
        window.clearInterval(this.state.trigger);
      } else {
        state.text += state.textToBe[state.text.length];
      }

      this.setState({
        text: state.text,
        textToBe: state.textToBe,
      });

      if(props.app) {
        props.app.scroll();
      }
    };

    func();

    let trigger = setInterval(func, speed);
    this.setState({
      trigger
    });
  }

  render() {
    return {
      'pre': (<pre className={ this.props.className }>{ this.state.text }</pre>),
      'div': (<div className={ this.props.className }>{ this.state.text }</div>)
    }[this.state.type];
  }
}

export default RollingText;


// WEBPACK FOOTER //
// ./src/helper/RollingText.js